import { Spin } from 'antd';
import { useEffect, useState } from 'react';

interface Props {
  className?: string;
  delay?: number;
  chunkName?: string;
}

const ChunkLoading: React.FC<Props> = ({
  chunkName,
  className,
  delay = 300, // 默认延迟300ms
}) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible) return null;

  return (
    <div
      className={`h-full flex flex-col items-center justify-center ${className}`}
    >
      <Spin />
      {chunkName} chunk loading ...
    </div>
  );
};

export default ChunkLoading;
